module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-529-min.585d9860.jpg";